import { render, staticRenderFns } from "./DeleteMessageModal.vue?vue&type=template&id=f021c9ea&"
import script from "./DeleteMessageModal.vue?vue&type=script&lang=js&"
export * from "./DeleteMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports